import { Link } from 'react-router-dom';
import { GraduationCap, ShieldCheck, Instagram, Facebook, Youtube } from 'lucide-react';
import stripeLogo from '@/assets/stripe-logo-transparent.svg';
import { lazy, Suspense } from 'react';

const LeadMagnetBanner = lazy(() => import('@/components/engagement/LeadMagnetBanner').then(m => ({ default: m.LeadMagnetBanner })));

export function Footer() {
  return (
    <footer className="border-t">
      <div className="container py-12">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 justify-items-center text-center max-w-4xl mx-auto">
          {/* Explore */}
          <div>
            <h4 className="font-semibold mb-4">Explore</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/browse" className="hover:text-foreground transition-colors">Browse Classes</Link></li>
              <li><Link to="/browse?type=virtual" className="hover:text-foreground transition-colors">Virtual Classes</Link></li>
              <li><Link to="/browse?type=in_person" className="hover:text-foreground transition-colors">In-Person Classes</Link></li>
            </ul>
          </div>

          {/* Teach */}
          <div>
            <h4 className="font-semibold mb-4">Teach</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/teach" className="hover:text-foreground transition-colors">Start Teaching</Link></li>
              <li><Link to="/pricing" className="hover:text-foreground transition-colors">Instructor Pricing</Link></li>
              <li><Link to="/instructor/marketing" className="hover:text-foreground transition-colors">Marketing Tools</Link></li>
              <li><Link to="/find-a-venue" className="hover:text-foreground transition-colors">Find a Venue</Link></li>
            </ul>
          </div>

          {/* Policies */}
          <div>
            <h4 className="font-semibold mb-4">Policies</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/privacy" className="hover:text-foreground transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-foreground transition-colors">Terms & Conditions</Link></li>
              <li><Link to="/cookies" className="hover:text-foreground transition-colors">Cookie Policy</Link></li>
              <li><Link to="/disclaimer" className="hover:text-foreground transition-colors">Disclaimer</Link></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-semibold mb-4">Support</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/faqs" className="hover:text-foreground transition-colors">Help Center</Link></li>
              <li><Link to="/contact" className="hover:text-foreground transition-colors">Contact</Link></li>
              <li><Link to="/suggestions" className="hover:text-foreground transition-colors">Suggestions</Link></li>
              <li><Link to="/faqs" className="hover:text-foreground transition-colors">FAQs</Link></li>
            </ul>
          </div>

          {/* Payments */}
          <div>
            <h4 className="font-semibold mb-4">Payments</h4>
            <div className="flex flex-col items-center gap-3">
              <div className="flex items-center gap-2">
                <ShieldCheck className="h-5 w-5 text-primary" />
                <span className="text-sm text-muted-foreground">Secured by</span>
              </div>
              <img src={stripeLogo} alt="Stripe" className="h-[36px] w-auto object-contain" width="86" height="36" />
              <p className="text-xs text-muted-foreground leading-relaxed">
                Payments processed securely by Stripe
              </p>
            </div>
          </div>
        </div>

        {/* Mini Lead Magnet */}
        <div className="max-w-sm mx-auto">
          <Suspense fallback={null}>
            <LeadMagnetBanner compact />
          </Suspense>
        </div>

        <div className="border-t mt-8 pt-8 flex flex-col items-center text-center gap-4">
          <Link to="/" className="flex items-center gap-2">
            <div className="flex h-8 w-8 items-center justify-center rounded-lg gradient-primary">
              <GraduationCap className="h-4 w-4 text-primary-foreground" />
            </div>
            <span className="font-serif text-lg font-medium">Learn Around Town</span>
          </Link>
          <p className="text-sm text-muted-foreground max-w-xs">
            Connect with local experts and learn new skills in your community.
          </p>
          <div className="flex items-center gap-4">
            <a href="https://www.instagram.com/mylearnaroundtown" target="_blank" rel="noopener noreferrer" aria-label="Follow us on Instagram" className="flex h-9 w-9 items-center justify-center rounded-full border transition-colors hover:opacity-80" style={{ color: '#E4405F', borderColor: '#E4405F' }}>
              <Instagram className="h-4 w-4" />
            </a>
            <a href="https://www.facebook.com/LearnAroundTown/" target="_blank" rel="noopener noreferrer" aria-label="Follow us on Facebook" className="flex h-9 w-9 items-center justify-center rounded-full border transition-colors hover:opacity-80" style={{ color: '#1877F2', borderColor: '#1877F2' }}>
              <Facebook className="h-4 w-4" />
            </a>
            <a href="https://www.youtube.com/@LearnAroundTown" target="_blank" rel="noopener noreferrer" aria-label="Subscribe on YouTube" className="flex h-9 w-9 items-center justify-center rounded-full border transition-colors hover:opacity-80" style={{ color: '#FF0000', borderColor: '#FF0000' }}>
              <Youtube className="h-4 w-4" />
            </a>
          </div>
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} Learn Around Town. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
